<template>
 
  <div id="Vue"  >
 
  <el-row >
  <el-col :span="22" :offset="1"> 
   
  <el-row  style=" padding:20px;margin-top:10px;background: #fff;  " justify="left"  >
  <el-breadcrumb separator-class="el-icon-arrow-right" style="  margin-top:3px;margin-left:10px;margin-bottom:30px;">
  <el-breadcrumb-item :to="{ path: '/customs/index' }">海关数据</el-breadcrumb-item>
  <el-breadcrumb-item>全球公司数据</el-breadcrumb-item> 
  </el-breadcrumb>
  <el-form ref="form"  :inline="true" :model="form" label-width="80px" class="demo-form-inline">
 
  <el-form-item label="类别">
    <el-select v-model="form.type" placeholder="请选择">
      <el-option label="公司名称" value="name"></el-option>
      <el-option label="行业描述" value="desc"></el-option> 
    </el-select>
  </el-form-item>   
  <el-form-item label="关键词">
    <el-input v-model="form.keywords" placeholder="请输入"  @keyup.enter.native="onSubmit"></el-input>
  </el-form-item>
  <el-form-item>
    <el-button type="primary" :loading="loading" @click="onSubmit" >查询</el-button>
  </el-form-item>
  </el-form>
  </el-row>
 
  <el-row style=" padding:20px;margin-top:10px;background: #fff;  " justify="left"  >
 
  
  <el-table id="tbl" v-loading="loading"
    :data="tableData" 
	border 
    style="width: 100%;height:600px"
	 
     >
    <el-table-column
      prop="id"
      label="id" 
	  v-if="id==0" 
      width="1%">
    </el-table-column>
    <el-table-column
      fixed
      prop="COMPANY_NAME"
      label="公司名称"
      min-width="16%">
    </el-table-column>
    <el-table-column
      fixed
      prop="COUNTRY_NAME"
      label="国家"
      min-width="8%">
    </el-table-column>	

    <el-table-column
      fixed
      prop="CONTACT_NAME"
      label="姓名"
      min-width="10%">
    </el-table-column>
    <el-table-column
      fixed
      prop="JOB_TITLE"
      label="职位"
      min-width="10%">
    </el-table-column>	
	
    <el-table-column style="font-size:20px;"
      fixed
      prop="EMAIL"
      label="邮箱" 
      min-width="10%">
    </el-table-column>
    <el-table-column
      prop="PHONE_NUMBER"
      label="电话"
      min-width="5%">
    </el-table-column>		
    <el-table-column
      prop="FAX_NUMBER"
      label="公司电话"
      min-width="5%">
    </el-table-column>	
    <el-table-column
      prop="WEB_ADDRESS"
      label="网址"
      min-width="5%">
    </el-table-column> 	
    <el-table-column
      prop="SIC_DESCRIPTION"
      label="行业描述"
      min-width="10%">
    </el-table-column>
    <el-table-column
      prop="ADDRESS"
      label="地址"
      min-width="5%">
    </el-table-column>
    <el-table-column
      prop="CITY"
      label="城市"
      min-width="3%">
    </el-table-column>
    <el-table-column
      prop="STATE"
      label="州"
      min-width="3%">
    </el-table-column>	


  </el-table>
  <div style="margin-top:10px; display: flex; align-items:right; justify-content: flex-end;  ">
  <el-tag v-show="!loading">当前:第{{page}}页</el-tag>
  <el-pagination v-show="!loading" @current-change="handlePageChange" :current-page="page" :page-size="10" layout="total  " :total="total">
				</el-pagination> 
  <el-button-group v-show="!loading" >
  <el-button type="primary" icon="el-icon-arrow-left" size="mini" :disabled="status" @click="getInfo('prev')">上一页</el-button>
  <el-button type="primary" size="mini" :disabled="status" @click="getInfo('next')">下一页<i class="el-icon-arrow-right el-icon--right"></i></el-button>
  </el-button-group>				
  </div>
  </el-row>  
  </el-col>
  </el-row>
</div>
</template>
<style>
  .el-header {
    background-color: #B3C0D1;
    color: #333;
    line-height: 60px;
  }
  
  .el-aside {
    color: #333;
  }
</style>

<script>
  
export default {
 
        data () {
            return {
	    	componentName: 'info',
		    userInfo: {},
			loading: false,
			login_state : false,
			id: 0,
			page: 0,
			size:10,
		    total: 0,
			buttonQuery: 1,
			status:true,
			tableHeight: '600px',
			dialogVisible: false,
			form:{ region:'', 
			       keywords:'',
				   type: '', 
				   
				   COMPANY_NAME:'',
				   SIC_DESCRIPTION: '',
				   EMAIL: '',
				   ADDRESS: '',
				   CITY:'',
				   PHONE_NUMBER:'',
				   FAX_NUMBER:'',
				   STATE: '', 
				   
				 },
			tableData:[],
			}  
        },
        methods: {
		    handleDetail(index, row){
			   localStorage.setItem('billId', row.id);
			    
			   this.dialogVisible = true;
			   
			},
		    handleSelect(key, keyPath) {
	           if (key == 1)
			      this.back();
				  
	           if (key == 2)
			      this.login();				  
			},
			handlePageChange(val) {
				this.page = val;
				this.buttonQuery = 0;
				//保存到localStorage
				localStorage.setItem('adPage', this.page)
				localStorage.setItem('adFilterForm', JSON.stringify(this.filterForm));
				this.getInfo()
			},		
		    onSubmit(){
				if (this.form.keywords == ''){
				    this.$message({
							message: '关键词不能为空 ! ',
							type: 'warning'
							});
				    return;
				}			    
			
			    this.page = 0;
				this.id = 0;
				this.buttonQuery = 1;
				this.getInfo('query');
				},
			getInfo(val){
				let that = this; 
 
				if (val == 'next'){
				    if (that.page * 10 >= that.total){
				    this.$message({
							message: '已到末页 ! ',
							type: 'error'
							});
				    return;
				    }  
				   }
				if (val == 'prev'){
				    if (that.page == 1){
				    this.$message({
							message: '已到首页 ! ',
							type: 'error'
							});
				    return;
				    }  
				   }
 
				let curPage = 0;
				if (val == "next"){
				    curPage = that.page + 1 ; 
					that.id = that.tableData[9].id;
					}
			    if (val == "prev"){
				    curPage = that.page - 1 ;
					that.id = that.tableData[0].id;
					}
				if (val == "query")
				    curPage = 1 ;
					
				let userInfo = localStorage.getItem('userInfo'); //判断登录状态
				console.log( 'user:' + typeof userInfo);  
				if ((userInfo == null || userInfo == '' || typeof userInfo == undefined ) && curPage > 1){
				    this.$message({
							message: '登录后查看更多 ! ',
							type: 'success'
							});
				    return;
				}
				let info = {};
				let user_id = 0;
				if (userInfo != null && userInfo != '' && typeof userInfo != undefined){
				    info = JSON.parse(userInfo);
				    user_id = info.id;  
					}
					
				that.loading = true;
				that.tableHeight = "800px";
				  $.ajax({
					  type: "POST",
					  data:  {user_id: user_id, 
					          page: curPage , 
							  size: 10, 
							  id: that.id,
							  region: that.form.region,
							  type:that.form.type,
							  keywords:that.form.keywords,
							  buttonQuery: that.buttonQuery,
							  direction: val,
							  },
					  url: "https://www.myferp.com/admin/user/emailSearch",
					  dataType: "json",  //返回类型为 json
					  beforeSend: function (request) {
						request.setRequestHeader("X-Nideshop-Token", localStorage.getItem('token') );
						},   
					  error: function(XMLHttpRequest, textStatus, errorThrown) { 
						  that.loading = false;
						  that.$message({
							message: data,
							type: 'error'
							});
								return false;
							},             
					  success: function (data) {
						
						  console.log(JSON.stringify(data));
						  if (data.errno == 500){
						      that.$message({
							  message: '未查询到相关数据， 换个词试试! ',
							  type: 'error'
							  });
							  that.loading = false;	
                              that.status = true;	
							  that.total = 0;
							  $("#tbl").attr("style","width:100%;height:500px");
							  that.page = 0;
							  that.id = 0;
                              that.tableData = [];							  
							  return;
						     }
						if (data.errno == 200){  //非注册用户每天查询最多两次
						      that.$message({
							  message: '登录后查看更多! ',
							  type: 'error'
							  });
							  that.loading = false;	
                              that.status = true;	
							  that.total = 0;
							  $("#tbl").attr("style","width:100%;height:500px");
							  that.page = 0;
							  that.id = 0;
                              that.tableData = [];							  
							  return;
						     }
						if (data.errno == 100){  //未付费注册用户每天查询最多五次
						      that.$message({
							  message: '成为会员后查看更多! ',
							  type: 'error'
							  });
							  that.loading = false;	
                              that.status = true;	
							  that.total = 0;
							  $("#tbl").attr("style","width:100%;height:500px");
							  that.page = 0;
							  that.id = 0;
                              that.tableData = [];							  
							  return;
						     }
						  that.tableData = data.data.data ; 
						  that.page = parseInt(data.data.currentPage )  ; 
						  that.total = data.data.count;
						  if (that.total >= 1) 
						     $("#tbl").attr("style","width:100%");
						  else 
						     $("#tbl").attr("style","width:100%;height:500px");
						   
						  that.id = data.data.id;
						  that.loading = false;	
                          that.status = false;						  
						  }
					  });
		    },
			
			login()
			{
			  this.$router.push({
					path: '/login',
					params: {
					  sometext: ''
					}
				  }); 
			},

			back()
			{ 
			  this.$router.push({
					path: '/home/index',
					params: {
					  sometext: ''
					}
				  });  
			},
 

		},
        mounted() { 
		    this.form.type = 'name';
			this.form.region = 'us'; 
			console.log( 'height: ' + $("#tbl").attr("style") );
			let userInfo = localStorage.getItem('userInfo');
				console.log( 'user:' + typeof userInfo);  
				if (userInfo == '' || userInfo == null  || typeof userInfo == undefined ){
				    this.login_state = false;
				}else{
				    this.login_state = true;
				}
           },		   
		
    } ;

</script>
 


// WEBPACK FOOTER //
// src/components/customs/emailSearch.vue